import { atom } from 'jotai';
import { AlertColor } from '@mui/material';

export const MessageAtom = atom<{ message: string; type?: AlertColor }>({
  message: '',
});
